// removed by extract-text-webpack-plugin
module.exports = {"container":"antd-pro-header-dropdown-container"};


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/src/components/HeaderDropdown/index.less
// module id = 1096
// module chunks = 0